export enum AnalyticsUserProperties {
    EMAIL = 'email',
    INTERNAL_USER = 'internal_user',
}
